// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"137":"88c36237","145":"a7e526e3","245":"1ceafbe9","298":"72be0dd4","383":"3e9a0f71","487":"21879a7e","791":"484bae1d","844":"da264e17","875":"a7e526e3"}[chunkId] + ".chunk.css";
};